import { render, staticRenderFns } from "./ContrattiFarmacia.vue?vue&type=template&id=39bf038c&"
import script from "./ContrattiFarmacia.vue?vue&type=script&lang=js&"
export * from "./ContrattiFarmacia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports